<template>

    <div class="card">
            
        <div class="bg-blue-light p-1">
            <TitleButton 
                :showBtn="true"
                :showAddNew="false"
                title="IPD - Admission"
                @onClickCloseButton="onClickCloseButton"
            />
        </div>

        <div class="note-section py-1">
            <h3 class="px-2 mt-1 note-head">Patient Details</h3>
            <PatientProfile 
                v-if="infoLoaddedStatus === 'done'"
                :doctors="admittedByUsers"
                v-model:profileId="formData.contact_profile_id"
                :isDisabled="Boolean($route.params.admissionId)"
                :class="$route.params.admissionId ? 'disabled-element' : ''"
            />

            <div class="col-12 col-sm-6 col-md-6 col-lg-4 px-2 mt-10">
                <label for="colFormLabel" class="form-label">Referrer: </label>
                <AsyncSelect
                    placeholder="Select Referrer"
                    v-model="referrer"
                    :api-service="fetchContactProfiles"
                    :additional-query="{ type: 'agent' }"
                    label="name"
                />
            </div>
        </div>

        <div class="row mt-2 py-1 note-section">
            <h3 class="px-2 note-head">Admission Info</h3>
            
            <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                <label for="colFormLabel" class="col-form-label"><span class="required">*</span> Bed / Cabin: </label>
                <v-select 
                    placeholder="Select bed/cabin" class="w-100"
                    :options="beds" label="name" 
                    :reduce="(name) => name.id"
                    v-model="formData.service_resource_id"
                    :selectable="bed => bed.service_general_status === 'open'"
                >
                    <template v-slot:option="bed">
                        {{ bed.name }}
                        <span class="badge badge-light-dark font-small-3">{{ bed.service_general_status }}</span>
                    </template>
                </v-select>
            </div>

            <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                <label for="colFormLabel" class="col-form-label">Department</label>
                <div class="input-group input-group-merge w-100">
                    <v-select 
                        placeholder="Select department" class="w-100" 
                        :options="departments" label="name"
                        :reduce="(name) => name.id" 
                        v-model="formData.department_id"
                    />
                </div>
            </div>

            <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                <label for="colFormLabel" class="col-form-label"><span class="required">*</span> Admission date</label>
                <div class="input-group input-group-merge w-100">
                    <input
                        v-model="formData.admission_date"
                        name="datetime"
                        type="datetime-local"
                        class="form-control"
                    />
                </div>
            </div>

            <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                <label for="colFormLabel" class="col-form-label"><span class="required">*</span> Referred Doctor: </label>
                <v-select 
                    placeholder="Select Referred Doctor" class="w-100" 
                    :options="consultants" label="name"
                    :reduce="(name) => name.id" 
                    v-model="formData.human_resource_id"
                />
            </div>

            <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                <label for="colFormLabel" class="col-form-label"><span class="required">*</span> Consultant: </label>
                <v-select 
                    placeholder="Select Consultant Doctor" class="w-100" 
                    :options="admittedByUsers" label="name"
                    :reduce="(name) => name.id" 
                    v-model="formData.consultant_id"
                />
            </div>

            <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                <label for="colFormLabel" class="col-form-label">Nurse: </label>
                <v-select 
                    placeholder="Select nurse" class="w-100" 
                    :options="nurses" label="name"
                    :reduce="(name) => name.id"
                    v-model="formData.nurse_id"
                />
            </div>

            <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                <label for="colFormLabel" class="col-form-label"><span class="required">*</span> Admitting Doctor: </label>
                <v-select 
                    placeholder="Select Admitting Doctor" class="w-100" 
                    :options="admittedByUsers" label="name"
                    :reduce="(name) => name.id"
                    v-model="formData.admitted_by"
                />
            </div>
        </div>

        <div class="row note-section py-1 mt-2">
            <h3 class="px-2 mt-2 note-head">Admission Notes</h3>
            <div class="col-12 col-md-12 note-section">
                <PhcNote 
                    @openModal="onOpenPhcModal"
                    :note="phcNote"
                />
            </div>
            <div class="row note-section">
                <div 
                  v-for="(note, index) in noteTypes" 
                  :key="note.value" 
                  class="col-6 col-md-6"
                >
                    <AdmissionNote
                      :note="note"
                      :index="index"
                      @openModal="openModal"
                    />
                </div>
            </div>
        </div>

       <div v-if="infoLoaddedStatus === 'loading'" class="col-12 col-sm-3 col-md-4 col-lg-4">
            <Loader />
        </div>

        <div class="row">
            <div class="col-12 text-center mb-3">
                <hr>
                <div class="dropdown d-inline-block me-1 mt-1">
                    <button :disabled="loading" type="button" class="btn btn-primary waves-effect waves-float waves-light" data-bs-toggle="dropdown" aria-expanded="false">
                        <div v-if="loading" class="spinner-border spinner-border-sm text-light me-1" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <i v-if="!loading" class="fas fa-save me-1"></i>
                        {{ loading ? 'Saving...' : 'Save' }}
                    </button>
                    <ul class="dropdown-menu">
                        <li>
                            <a class="dropdown-item" href="javascript:void(0)" @click="submit('dynamic')">
                                <i class="fas fa-print me-2"></i> Save & Print Dynamic Form
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" href="javascript:void(0)" @click="submit('static')">
                                <i class="fas fa-print me-2"></i> Save & Print Static Form
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <AddNoteModal
            v-if="store.state.isModalOpen"
            :note="singleNote"
        />
        <AddPhcNoteModal
            v-if="store.state.isModalOpenFour"
            @onUpdatePhc="OnUpdatePhc"
            :phcNote="phcNote"
        />

        <Loader v-if="loading"/>
    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import { inject, onMounted, reactive, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getCurrentDateTime, json_string_parse } from '@/services/utils/global.js'
import { useStore } from 'vuex';
import handleHospital from '@/services/modules/hospital'
import AdmissionNote from '@/components/molecule/company/hospital/note/Note.vue';
import AddNoteModal from '@/components/molecule/company/hospital/note/AddNoteModal.vue';
import PatientProfile from '@/components/molecule/company/hospital/ipd-register/PatientProfile.vue'
import PhcNote from '@/components/molecule/company/hospital/ipd-register/PhcNote.vue'
import AddPhcNoteModal from '@/components/molecule/company/hospital/ipd-register/AddPhcNoteModal.vue'
import handleContact from '@/services/modules/contact'
import Loader from "@/components/atom/LoaderComponent";
import handleBarcode from "@/services/modules/barcode";
import useDate from '@/services/utils/day';
import ipdAdmission from '@/services/utils/pdf/ipdAdmission';
import ipdStaticAdmission from '@/services/utils/pdf/ipdStaticAdmission';
import handleCompany from "@/services/modules/company";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import {useAsyncDropdownHelper} from "@/services/utils/asyncDropdownHelper";

const $router = useRouter();
const $route = useRoute();
const store = useStore();
const singleNote = ref(null);
const loading = ref(false);
const loader = ref(false);
const consultants = reactive([]);
const beds = reactive([]);
const admittedByUsers = reactive([]);
const nurses = reactive([]);
const departments = reactive([]);
const noteTypes = reactive([]);
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const infoLoaddedStatus = ref('loading');
const phcNote = ref(null);
const referrer = ref(null);
const companyInfo = ref({});

const {
    fetchServiceList,
    fetchDepartList,
    fetchAdmissionNoteList,
    storeRegistration,
    updateRegistration,
    fetchSingleNote
} = handleHospital()

const { fetchContactProfiles } = handleContact();
const { fetchBarcode } = handleBarcode();
const { formatDate } = useDate();
const { exportToPDF } = ipdAdmission();
const { exportToStaticPDF } = ipdStaticAdmission();
const { fetchCompanyInfo } = handleCompany();
const { formatPatientLabel } = useAsyncDropdownHelper()

const formData = ref({
    company_id: $route.params.companyId,
    human_resource_id: null,
    service_resource_id: null,
    contact_profile_id: null,
    consultant_id: null,
    admitted_by: null,
    nurse_id: null,
    admission_date: getCurrentDateTime(),
    department_id: null,
    referrer_id: null,
    notes: [],
    status: 'active',
})

const OnUpdatePhc = (phcFormData) => {
    phcNote.value = phcFormData
}

const onOpenPhcModal = () => {
    store.state.isModalOpenFour = true
}

const validateFormData = () => {
    if(! formData.value.human_resource_id) {
        showError('Please select Referred Doctor');
        return false;
    }

    if(! formData.value.consultant_id) {
        showError('Please select Consultant');
        return false;
    }
    
    return true;
}

const submit = async(printType) => {
    const isValidated = validateFormData();
    if(! isValidated) return;

    const admissionId = $route.params.admissionId;
    formData.value.notes = formatNotes();

    if(phcNote.value){
        formData.value.phc_notes = phcNote.value;
    }
    formData.value.referrer_id = referrer.value ? referrer.value.id : null;
    
    loading.value = true;

    const regMethod = admissionId ? updateRegistration : storeRegistration;
    await regMethod(formData.value, admissionId).then(async (res) => {
        loading.value = false
        if (!res.status){
            showError(res.message)
            return;
        }
        
        showSuccess(res.message);
        
        await onSelectPrintForm(printType, res.data.id);

        resetForm();
        onClickCloseButton();
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const onSelectPrintForm = async (type, id) => {
    if (type === 'static') {
        await getSingleIpdRegister(id, 'pdf');
        exportToStaticPDF(companyInfo.value, formData.value);
        onClickCloseButton();
        return;
    } 
    
    if (type === 'dynamic') {
        await goToPrint(id);
        onClickCloseButton();
    }
}

const goToPrint = async(id) => {
    let barcodeAdmission = null;
    let barcodePatient = null;
    let qrCode = null;
    const userName = store.state.user.user.name;

    await getSingleIpdRegister(id, 'pdf');

    let qrCodeData = JSON.stringify({
        ref_no: formData.value.admission_no,
        ref_date: formData.value.admission_date,
        created_by: userName,
        created_date_time: formatDate(new Date())
    })

    var barCodeQuery = `?code=${formData.value.patient.serial_no}&qrcode=${qrCodeData}`;
    var barCodeAdmissionQuery = `?code=${formData.value.admission_no}`;

    loading.value = true;

    await Promise.all([
        fetchBarcode(barCodeQuery).then( (res) => {
            barcodePatient = res.barcode
            qrCode = res.qrcode;
        }),
        fetchBarcode(barCodeAdmissionQuery).then( (res) => {
            barcodeAdmission = res.barcode;
        })
    ]).then(() => {
        exportToPDF(companyInfo.value, formData.value, qrCode, barcodePatient, barcodeAdmission)
    }).catch((e) => {
        console.log(e);
    }).finally(() => {
        loading.value = false
    })
}

const getCompanyInfo = async () => {
    await fetchCompanyInfo($route.params.companyId).then((res) => {
        companyInfo.value = res.data
    })
}

const resetForm = () => {
    formData.value = {
        company_id: $route.params.companyId,
        human_resource_id: null,
        service_resource_id: null,
        contact_profile_id: null,
        admitted_by: null,
        referrer_id: null,
        nurse_id: null,
        consultant_id: null,
        admission_date: getCurrentDateTime(),
        department_id: null,
        notes: [], 
        status: 'active',
    }
}
const formatNotes = () => {
   return noteTypes.filter(item => item.selectedNotes.length)
    .map(item => {
        return {
            id: item.id ? item.id : '',
            type: item.value,
            note: JSON.stringify(item.selectedNotes),
            new_notes: item.newNotesByDoctor,
        }
    })
}

const openModal = ({note, index}) => {
    singleNote.value = null;
    singleNote.value = {
        index: index,
        name: note.name,
        value: note.value,
        selectedNotes: note.selectedNotes,
        preAddedNotes: json_string_parse(note.preAddedNotes),
        noteMasters: note.noteMasters, 
        newNotesByDoctor: note.newNotesByDoctor,
    }
    
    if(singleNote.value){
        store.state.isModalOpen = true;
    }
}

const onClickCloseButton = () => {
    $router.push({name: 'ipd-register',
        params: {
            companyId: $route.params.companyId,
            moduleId: $route.params.moduleId,
            menuId: $route.params.menuId,
            pageId: $route.params.pageId,
        },
        query: $route.query,
    })
}

function getQuery() {
    let query = `?company_id=${$route.params.companyId}&search_type=all`;
    return query;
}

const getSingleIpdRegister = async (id = null, from = null) => {
    if(!id){
        infoLoaddedStatus.value = 'done';
        return;
    };

    let query = getQuery();

    await fetchSingleNote(query, id).then((res) => {
        if (!res.status) return showError(res.message);
        formData.value = res.data;
        referrer.value = res.data.referrer;

        if(from === 'pdf'){
            infoLoaddedStatus.value = 'done';
            return;
        }

        phcNote.value = res.data.phc_general;
        setNoteData(res.data.notes)
        infoLoaddedStatus.value = 'done';
    })
}

const setNoteData = (notes) => {
    for(let note of notes){
        const index = noteTypes.findIndex(item => item.value === note.type);
        if(index < 0) continue;
        noteTypes[index].id = note.id;
        noteTypes[index].selectedNotes = note.note;
    }
}

onMounted( async () => {
    const query = getQuery();
    const admissionId = $route.params.admissionId;
    
    loader.value = true;
    await Promise.all([
        fetchServiceList(query, 'human_resources').then((res) => {
            if(res.status) consultants.push(...res.data)
        }),
        fetchServiceList(query, 'places').then((res) => {
            if(res.status) beds.push(...res.data)
        }),
        fetchContactProfiles(query + `&type=nurse`).then((res) => {
            if(res.status) nurses.push(...res.data)
        }),
        fetchContactProfiles(query + `&type=doctor`).then((res) => {
            if(res.status) admittedByUsers.push(...res.data)
        }),
        fetchDepartList(query).then((res) => {
            if(res.status) departments.push(...res.data)
        }),
        fetchAdmissionNoteList(query).then((res) => {
            if(res.status) noteTypes.push(...res.data)
        }),
        getCompanyInfo()
    ]).then(() => {
        getSingleIpdRegister(admissionId);
        loader.value = false;
    }).catch((err) => {
        loader.value = false
    });
})
</script>

<style scoped>
.note-section {
    margin-top: 5px;
    box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
    width: 96%;
    margin-left: 2%;
}
.mt-10 {
    margin-top: 10px;
}
.note-head {
    color: #7367f0;
}
</style>